import React from "react"
import { Grid, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { TEXT_SECONDARY_COLOR, FONT_FAMILY_PRIMARY } from "../../theme"
import Modal from "./Modal"

const ModalCadastroAmostrasErro = ({
    modalAberto,
    setModalAberto,
    handleClickBotaoModal,
    carregandoModal }) => {

    const classes = useStyles()

    const handleFecharModal = () => {
        setModalAberto(false)
    }

    return (
        <Modal
            modalAberto={modalAberto}
            desabilitarCliqueForaModal={false}
            iconeFechar={true}
            titulo={"Não foi possível concluir o cadastro da amostra com leitor"}
            maxWidth={"xs"}
            fecharModal={handleFecharModal}
            botaoSecundario={{
                texto: "Voltar para cadastro",
                atalho: "(ESC)",
                acao: () => handleClickBotaoModal(),
                carregando: carregandoModal
            }}
            className={classes.modalCadastroAmostrasErro}
        >
            <Grid container className={"pr-2 pl-2 pt-50 pb-5"}>
                <Grid align="center" item xs={12}>
                    <Typography className={classes.gridDados}>
                        Tivemos um problema ao registrar sua amostra. Você pode solicitar o envio de sua requisição novamente ou tentar mais tarde.
                    </Typography>
                </Grid>
            </Grid>
        </Modal>
    )
}

const useStyles = makeStyles((theme) => ({
    modalCadastroAmostrasErro: {},
    gridDados: {
        width: "340px",
        height: "66px",
        left: "445px",
        top: "342px",
        align: "center",

        fontFamily: FONT_FAMILY_PRIMARY,
        fontSize: "14px",
        lineHeight: "22px",
        textAlign: "center",

        color: TEXT_SECONDARY_COLOR
    },
}))

export default ModalCadastroAmostrasErro